<script lang="ts" setup>
import type {IAddress} from '@/types/address';

const props = defineProps<{ addresses: IAddress[], maxAddresses: number }>()

const emit = defineEmits<{ (e: 'remove', index: number): void }>()

const addressTitles = ['Current Address', 'Past Address']
</script>

<template>
  <div v-if="props.addresses.length" class="flex flex-col space-y-4 mb-6 max-w-full">
    <div v-for="(address, index) in props.addresses"
         :key="`${address.street}-${address.city}-${address.state}`"
         class="flex justify-between items-start border-l-4 border-green-500 rounded-md pl-2 py-1 shadow transition max-w-full">
      <div>
        <h3 class="font-medium text-base">{{ addressTitles?.[index] || addressTitles[1] }}</h3>
        <p class="text-sm mt-1">{{ address.street }}, {{ address.city }}, {{ address.state }}</p>
      </div>
      <div v-if="index > 0 || props.addresses.length === 1">
        <button
          class="text-(--brand-primary) hover:text-green-700 cursor-pointer transition"
          @click="emit('remove', index)">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 m-2" fill="none"
               viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <span
        class="text-[10px] px-1 mx-2 mt-2 uppercase text-(--brand-primary) border border-(--brand-primary) inline-block rounded"
        v-else>Primary</span>
    </div>
  </div>
</template>
